import type { SideBarItem } from '@/app/shell/SideBar';
import { ROUTES } from '@/shared/constants/routes';
import type { TFunction } from 'i18next';
import { Cable, Coins, CreditCard, ScanSearch, ScrollText, Sparkles } from 'lucide-react';

export function buildAdminSidebarItems(
  t: TFunction,
  {
    showDiagnostic,
    credits,
  }: {
    showDiagnostic: boolean;
    credits: 'internal' | 'customer' | null;
  },
): SideBarItem[] {
  const sideBarItems: SideBarItem[] = [
    {
      key: 'mcp',
      label: t('dataset.sidebar.mcp'),
      icon: Sparkles,
      path: ROUTES.MCP,
      group: 'admin-config',
    },
    {
      key: 'billing',
      label: t('billingPage.title'),
      icon: CreditCard,
      path: ROUTES.BILLING,
      group: 'admin-config',
    },
    {
      key: 'audit-logs',
      label: t('audit.title'),
      icon: ScrollText,
      path: ROUTES.AUDIT_LOGS,
      group: 'advanced',
      requiredPermission: 'audit_log:view',
    },
    {
      key: 'private-connections',
      label: t('privateConnections.title'),
      icon: Cable,
      path: ROUTES.PRIVATE_CONNECTIONS,
      group: 'advanced',
      requiredPermission: 'private_connection:view',
    },
  ];

  if (showDiagnostic) {
    sideBarItems.push({
      key: 'diagnostic',
      label: t('diagnostic.page.title'),
      icon: ScanSearch,
      path: ROUTES.DIAGNOSTIC,
      group: 'advanced',
    });
  }

  const creditsItem: SideBarItem = {
    key: 'credits',
    label: t('credits.title'),
    icon: Coins,
    path: ROUTES.CREDITS,
    group: 'advanced',
  };
  if (credits === 'internal') sideBarItems.push(creditsItem);
  if (credits === 'customer') {
    sideBarItems.push({
      ...creditsItem,
      requiredPermission: 'ai_usage:view',
      hideWhenDenied: true,
    });
  }

  return sideBarItems;
}
